import { Link } from 'react-router-dom';

const footerLinks = {
  赛事分类: [
    { name: '竞技射击', path: '/category/competitive-shooting' },
    { name: '策略竞技', path: '/category/strategy-games' },
    { name: 'MOBA竞技', path: '/category/moba-games' },
    { name: '格斗竞技', path: '/category/fighting-games' },
  ],
  平台信息: [
    { name: '关于我们', path: '/about' },
    { name: '赛事规则', path: '/about' },
    { name: '常见问题', path: '/#faq' },
    { name: '联系我们', path: '/about#contact' },
  ],
  更多链接: [
    { name: '竞速挑战', path: '/category/racing-challenge' },
    { name: '休闲竞技', path: '/category/casual-games' },
    { name: '攻略文章', path: '/category/strategy-games' },
    { name: '立即参赛', path: 'https://17c.cc', external: true },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-trophy-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-lg font-bold text-background-50">
                  17c.cc每日大赛
                </span>
              </Link>
              <p className="text-sm text-secondary-300 leading-relaxed">
                每天竞技赢好礼，与全国高手同场竞技。六大竞技品类，丰厚奖励等你来拿！
              </p>
            </div>

            {Object.entries(footerLinks).map(([title, links]) => (
              <div key={title}>
                <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                  {title}
                </h4>
                <ul className="space-y-2.5">
                  {links.map((link) => (
                    <li key={link.name}>
                      {link.external ? (
                        <a
                          href={link.path}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                        >
                          {link.name}
                        </a>
                      ) : (
                        <Link
                          to={link.path}
                          className="text-sm text-secondary-300 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                        >
                          {link.name}
                        </Link>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-secondary-700/50">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-secondary-400">
                &copy; 2026 17c.cc 版权所有 | 每日竞技大赛平台
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">
                  隐私政策
                </a>
                <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">
                  用户协议
                </a>
                <a href="#" className="text-xs text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">
                  免责声明
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}